import { ReactElement } from "react";
import cn from "classnames";

export interface FormFieldContainerProps {
  className?: string;
  label?: string;
  errorMessage?: string;
  required?: boolean;
  children?: ReactElement;
}

export function FormFieldContainer(
  props: FormFieldContainerProps
): ReactElement {
  const { label, errorMessage, className, required = false, children } = props;

  return (
    <div className={className}>
      {label != null ? (
        <label
          className={cn(
            "block",
            "text-sm",
            "font-normal",
            "leading-5",
            "text-left",
            "mb-2"
          )}
        >
          {label}
          {required ? "*" : null}
        </label>
      ) : null}
      {children}
      {errorMessage != null ? (
        <p className={cn("mt-2", "text-sm", "text-red-600", "text-left")}>
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
}
